import React, { useState, useEffect } from "react";
import CustomErrorModal from "../components/sharedComponents/CustomErrorModal";
import { useNavigate } from "react-router-dom";
import Banner from "../components/sharedComponents/Banner";
import Spinner from "../components/sharedComponents/Spinner";
import { GoArrowLeft } from "react-icons/go";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { post } from "aws-amplify/api";
import { useDispatch, useSelector } from "react-redux";
import Auth from "../utils/auth";
const GET_PROPOSAL_API_URL = process.env.REACT_APP_GET_PROPOSAL_API_URL;

export default function CertificateSelection() {
  const policies = useSelector((state) => state.policies);
  const cjson = localStorage.getItem("certificates");
  const certificates = JSON.parse(cjson);
  console.log(certificates);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [integrityConfirmation, setIntegrityConfirmation] = useState(false);
  const [triggerError, setTriggerError] = useState(false);
  const [insuranceCost, setInsuranceCost] = useState(0);
  const [deviceBrand, setDeviceBrand] = useState("");
  const [brandModel, setBrandModel] = useState("");
  const [deviceModel, setDeviceModel] = useState("");
  const [checkedPolicies, setCheckedPolicies] = useState({});
  const [selectAll, setSelectAll] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedImeis, setSelectedImeis] = useState([]);
  const mockPolicies = [
    {
      serviceName: "Proteccion Movil Prepago 1",
      serviceUrl: "https://d2pvek4cj0x31f.cloudfront.net/insuranceData",
      email: "ldmondragon@enki.mx",
      phone: "5537339801",
      model: "14 128",
      imei: 350000490032428,
    },
    {
      serviceName: "Proteccion Movil Prepago 2",
      serviceUrl: "https://d2pvek4cj0x31f.cloudfront.net/insuranceData",
      email: "ldmondragon@enki.mx",
      phone: "5537339801",
      model: "14 128",
      imei: 350596482085233,
    },
    // {
    //   serviceName: "Proteccion Movil Prepago 3",
    //   serviceUrl: "https://d2pvek4cj0x31f.cloudfront.net/insuranceData",
    //   email: "ldmondragon@enki.mx",
    //   phone: "5537339801",
    //   model: "14 128",
    //   imei: 350596482085233,
    // },
    // {
    //   serviceName: "Proteccion Movil Prepago 4",
    //   serviceUrl: "https://d2pvek4cj0x31f.cloudfront.net/insuranceData",
    //   email: "ldmondragon@enki.mx",
    //   phone: "5537339801",
    //   model: "14 128",
    //   imei: 350596482085234,
    // },
    // {
    //   serviceName: "Proteccion Movil Prepago 5",
    //   serviceUrl: "https://d2pvek4cj0x31f.cloudfront.net/insuranceData",
    //   email: "ldmondragon@enki.mx",
    //   phone: "5537339801",
    //   model: "14 128",
    //   imei: 350596482085235,
    // },
    // {
    //   serviceName: "Proteccion Movil Prepago 6",
    //   serviceUrl: "https://d2pvek4cj0x31f.cloudfront.net/insuranceData",
    //   email: "ldmondragon@enki.mx",
    //   phone: "5537339801",
    //   model: "14 128",
    //   imei: 350596482085236,
    // },
    // {
    //   serviceName: "Proteccion Movil Prepago 7",
    //   serviceUrl: "https://d2pvek4cj0x31f.cloudfront.net/insuranceData",
    //   email: "ldmondragon@enki.mx",
    //   phone: "5537339801",
    //   model: "14 128",
    //   imei: 350596482085237,
    // },
    // {
    //   serviceName: "Proteccion Movil Prepago 8",
    //   serviceUrl: "https://d2pvek4cj0x31f.cloudfront.net/insuranceData",
    //   email: "ldmondragon@enki.mx",
    //   phone: "5537339801",
    //   model: "14 128",
    //   imei: 350596482085238,
    // },
    // ... repeat for each item
  ];
  const itemsPerPage = 5;
  const itemsperPagination = 5; // Number of pages in each pagination group

  const totalPages = Math.ceil(certificates.length / itemsPerPage);
  const totalGroups = Math.ceil(totalPages / itemsperPagination);

  const [currentGroup, setCurrentGroup] = useState(1);

  const startPage = (currentGroup - 1) * itemsperPagination + 1;
  const endPage = Math.min(startPage + itemsperPagination - 1, totalPages);
  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = certificates.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleGroupChange = (direction) => {
    setCurrentGroup((prevGroup) =>
      direction === "next"
        ? Math.min(prevGroup + 1, totalGroups)
        : Math.max(prevGroup - 1, 1)
    );
  };

  async function sendCertificates() {
    console.log("validating");
    try {
      const restOperation = post({
        apiName: "ppmrestapi",
        path: "/certificates",
        options: {
          body: {
            imei: selectedImeis,
          },
        },
      });

      const { body } = await restOperation.response;
      const response = await body.json();
      if (response.code === "0") {
        console.log("Imeis sent successfully");
        const downloadUrl = response.data;
        console.log("Download URL: ", downloadUrl);
        localStorage.setItem("downloadUrl", downloadUrl);
        navigate("/certificado");

        // setPolicyException(true);
      }
    } catch (e) {
      console.log("POST call failed: ", JSON.parse(e.response.body));
      const errorBody = JSON.parse(e.response.body);
      console.log("Error body: ", errorBody);
    }
  }
  // useEffect(() => {
  //   console.log("WHAT I GOT ", policies);
  //   if (policies.length === 0) {
  //     navigate("/certificateConfirmation");
  //   }
  // }, []);
  useEffect(() => {
    if (!Auth.loggedIn()) {
      navigate("/home");
      return;
    }
    const initialPoliciesState = certificates.reduce(
      (acc, policy) => ({ ...acc, [policy.serviceName]: false }),
      {}
    );
    setCheckedPolicies(initialPoliciesState);
  }, []);

  const handleCheckboxChange = (policy) => {
    setCheckedPolicies((prevState) => {
      const newState = {
        ...prevState,
        [policy.imei]: !prevState[policy.imei],
      };

      // If the policy is being checked, add its imei to the selectedImeis array
      if (!prevState[policy.imei]) {
        setSelectedImeis((prevImeis) => {
          // Check if the policy's imei is already in the selectedImeis array
          if (prevImeis.includes(policy.imei)) {
            return prevImeis;
          }

          const newImeis = [...prevImeis, policy.imei];
          return newImeis;
        });
      } else {
        // If the policy is being unchecked, remove its imei from the selectedImeis array
        setSelectedImeis((prevImeis) => {
          const newImeis = prevImeis.filter((imei) => imei !== policy.imei);
          return newImeis;
        });
      }

      return newState;
    });
  };

  const handleSelectAllChange = () => {
    setSelectAll((prevState) => {
      const newState = !prevState;

      // If all policies are being checked, add all imeis to the selectedImeis array
      if (!prevState) {
        setSelectedImeis(certificates.map((policy) => policy.imei));
      } else {
        // If all policies are being unchecked, clear the selectedImeis array
        setSelectedImeis([]);
      }

      const newPoliciesState = certificates.reduce(
        (acc, policy) => ({ ...acc, [policy.imei]: newState }),
        {}
      );
      setCheckedPolicies(newPoliciesState);

      return newState;
    });
  };
  return (
    <section className="relative min-h-screen font-gotham place-items-center place-content-start grid phone:grid-cols-1 laptop:grid-cols-8">
      <div className="absolute laptop:top-0 phone:top-[45vw] laptop:left-[26vw] phone:left-[2vw] laptop:pt-5 phone:pt-5 tablet:pt-8">
        <button onClick={() => navigate("/ya-tengo-proteccionmovil")}>
          <GoArrowLeft className="text-primary laptop:h-8 laptop:w-8 phone:h-6 phone:w-6" />
        </button>
      </div>

      <Banner />
      {/* <div
        className="object-cover phone:row-span-1 laptop:col-span-2 flex items-center justify-center bg-red-500 phone:h-1/4  bg-top-quarter"
        style={{ backgroundImage: `url(${protectMovilImg})` }}
      /> */}
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col  phone:row-span-4  laptop:col-span-6 py-10 phone:mx-3">
          <h1 className="laptop:text-2xl phone:text- text-primary font-semibold laptop:py-6 text-center">
            Certificados encontrados
          </h1>
          <p className="text-[#6D80A4]">
            Elige el certificado que desees recibir por correo electrónico:
          </p>
          {/* <InsuranceDataModal /> */}
          <div className="m-auto mt-6 flex-col laptop:w-[30vw] phone:w-[85vw] h-80 shadow-lg justify-start rounded-lg items-start">
            <div className="flex justify-evenly"></div>
            <div className="flex flex-row items-center justify-start mb-1 bg-[#EAC360] rounded-t-lg bg-opacity-20">
              <input
                name="credit_payment"
                type="checkbox"
                checked={selectAll}
                onChange={handleSelectAllChange}
                className="mx-5 my-4 indeterminate:bg-gray-300 mr-2"
              />
              <label
                htmlFor="credit_payment"
                className=" ml-2 text-sm text-[#6D80A4]"
              >
                Seleccionar todos
              </label>
              <div className="flex text-xs laptop:ml-[14vw] phone:ml-[30vw] text-[#6D80A4]">
                <p>{currentPage}</p>
                <span className="mx-2">|</span>

                <p className="opacity-75">{totalPages}</p>
              </div>
            </div>
            {currentItems.map((policy, index) => (
              <div className="flex flex-row items-center my-2" key={index}>
                <input
                  name={policy.imei}
                  type="checkbox"
                  checked={checkedPolicies[policy.imei] || false}
                  onChange={() => handleCheckboxChange(policy)}
                  className="mx-5 my-4 indeterminate:bg-gray-300 mr-2"
                />
                <label
                  htmlFor={policy.serviceName}
                  className="ml-2 text-sm text-[#6D80A4]"
                >
                  {policy.serviceName}
                </label>{" "}
              </div>
            ))}
          </div>
          {/* className=
        {`mr-2 ${
          currentPage === number
            ? "text-[#6D80A4] text-[0.9rem]"
            : "text-gray-300"
        }`} */}
          <div className="flex justify-end mr-8 mt-2">
            {" "}
            <button
              className={`nav-button ${currentGroup === 1 ? "disabled" : ""} ${
                totalPages <= 5 ? "hidden" : ""
              }`}
              disabled={currentGroup === 1}
              onClick={() => handleGroupChange("prev")}
            >
              <MdKeyboardArrowLeft />
            </button>
            {pageNumbers.map((number) => (
              <li
                className={`cursor-pointer list-none mr-2 ${
                  currentPage === number
                    ? "text-[#6D80A4] text-[0.9rem]"
                    : "text-gray-300"
                }`}
                key={number}
                onClick={() => handlePageChange(number)}
              >
                {number}
              </li>
            ))}
            <button
              className={`nav-button ${
                currentGroup === totalGroups ? "disabled" : ""
              } ${totalPages <= 5 ? "hidden" : ""}`}
              disabled={currentGroup === totalGroups}
              onClick={() => handleGroupChange("next")}
            >
              {" "}
              <MdOutlineKeyboardArrowRight />
            </button>
          </div>
          <div
            className="space-y-6 flex flex-row justify-center items-center pt-20"
            action="#"
          >
            <button
              onClick={() => {
                setTriggerError(false);
                console.log("Selected Imeis", selectedImeis);
                setIsLoading(true);
                sendCertificates().finally(() => setIsLoading(false));
                // navigate("/");
              }}
              className="laptop:w-72 phone:w-[30vw] mt-6 text-white bg-orng hover:bg-primary 
              focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium
              rounded-lg text-base px-5 phone:px-3 py-2.5 text-center"
            >
              Enviar
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
